import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/editIcon.svg'
import _imports_1 from '@/assets/Collapse.svg'
import _imports_2 from '@/assets/plus.svg'
import _imports_3 from '@/assets/deleteIcon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-819c57a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-5 px-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Workflow")
  ])
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "card justify-center items-center flex mt-4" }
const _hoisted_5 = { class: "flex flex-col w-full bg-white" }
const _hoisted_6 = { class: "statuscontainer p-2" }
const _hoisted_7 = { class: "formcontainer flex flex-col" }
const _hoisted_8 = { class: "row flex flex-row w-full" }
const _hoisted_9 = { class: "w-1/2 p-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "workflowName",
  class: "controllabel w-1/2"
}, "WorkFlow*", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "w-1/2 p-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "configuration",
  class: "controllabel w-1/2"
}, "Link Configuration", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "0",
  selected: "",
  hidden: "",
  disabled: ""
}, "Please select screen", -1))
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "p-2 mt-5 flex items-center flex-row-reverse" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-5 w-5 mr-1"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-4" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "cursor-pointer" }, [
      /*#__PURE__*/_createElementVNode("div", null, "Status")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "cursor-pointer" }, [
      /*#__PURE__*/_createElementVNode("div", null, "Stage")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "cursor-pointer" }, [
      /*#__PURE__*/_createElementVNode("div", null, "To")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "cursor-pointer" }, [
      /*#__PURE__*/_createElementVNode("div", null, "Authority")
    ])
  ])
], -1))
const _hoisted_20 = { style: {"visibility":"hidden"} }
const _hoisted_21 = { style: {"visibility":"hidden"} }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"visibility":"hidden"} }, /*#__PURE__*/_toDisplayString(1111), -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { key: 3 }
const _hoisted_28 = { class: "buttonposition flex justify-end items-right my-3 mx-2" }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "card justify-center items-center flex mt-4" }
const _hoisted_31 = { class: "flex flex-col w-full bg-white" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex p-2 border-b border-solid border-lightgrey rounded-t" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "formcontainer mr-2 row flex flex-row w-full" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 w-6/12 p-2" }, [
      /*#__PURE__*/_createElementVNode("h1", null, "Create Workflow")
    ])
  ])
], -1))
const _hoisted_33 = { class: "statuscontainer px-2 pt-2" }
const _hoisted_34 = { class: "formcontainer row flex items-center" }
const _hoisted_35 = { class: "w-1/2 p-2" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "workflowName",
  class: "controllabel w-1/2"
}, "WorkFlow*", -1))
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_39 = {
  key: 0,
  class: "error-text"
}
const _hoisted_40 = { class: "w-1/2 p-2" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "configuration",
  class: "controllabel w-1/2"
}, "Link Configuration", -1))
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "0",
  selected: "",
  hidden: "",
  disabled: ""
}, "Please select screen", -1))
const _hoisted_44 = ["value"]
const _hoisted_45 = {
  class: "flex flex-row-reverse px-2 pt-5",
  id: "container"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "ml-2"
}, null, -1))
const _hoisted_47 = {
  key: 0,
  class: "addCard bg-white absolute cursor-pointer"
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border w-full" }, null, -1))
const _hoisted_50 = ["onClick"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-4 mt-4" }, null, -1))
const _hoisted_52 = { class: "p-2 mt-8" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Status"),
  /*#__PURE__*/_createElementVNode("th", null, "Stage"),
  /*#__PURE__*/_createElementVNode("th", null, "To"),
  /*#__PURE__*/_createElementVNode("th", null, "Authority"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Action")
], -1))
const _hoisted_54 = { key: 0 }
const _hoisted_55 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_56 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_57 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_58 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_59 = {
  key: 0,
  class: "error-text"
}
const _hoisted_60 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt-2",
  style: {"visibility":"hidden"}
}, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    class: "inputboxstyling"
  })
], -1))
const _hoisted_62 = { class: "mt-2" }
const _hoisted_63 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_64 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_65 = {
  key: 0,
  class: "error-text"
}
const _hoisted_66 = { class: "mt-2" }
const _hoisted_67 = ["onUpdate:modelValue"]
const _hoisted_68 = ["label"]
const _hoisted_69 = ["value"]
const _hoisted_70 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_71 = {
  key: 0,
  class: "error-text"
}
const _hoisted_72 = { class: "mt-2" }
const _hoisted_73 = ["onUpdate:modelValue"]
const _hoisted_74 = ["label"]
const _hoisted_75 = ["value"]
const _hoisted_76 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_77 = {
  key: 0,
  class: "error-text"
}
const _hoisted_78 = { class: "mt-2 w-52" }
const _hoisted_79 = ["onUpdate:modelValue"]
const _hoisted_80 = ["value"]
const _hoisted_81 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_82 = {
  key: 0,
  class: "error-text"
}
const _hoisted_83 = { class: "flex flex-row child-action-col justify-center" }
const _hoisted_84 = ["onClick"]
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "h-5 w-5 mr-2 mt-2"
}, null, -1))
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = ["onClick"]
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "h-5 w-5 mt-2"
}, null, -1))
const _hoisted_89 = [
  _hoisted_88
]
const _hoisted_90 = { class: "flex flex-row child-action-col justify-center" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "px-1 py-0 cursor-pointer",
  style: {"visibility":"hidden"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "h-5 w-5 mr-2 mt-2"
  })
], -1))
const _hoisted_92 = ["onClick"]
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "h-5 w-5 mt-2"
}, null, -1))
const _hoisted_94 = [
  _hoisted_93
]
const _hoisted_95 = { class: "buttonposition flex justify-end items-right mt-3 mb-3 mx-2" }
const _hoisted_96 = ["onClick"]
const _hoisted_97 = ["onClick"]
const _hoisted_98 = {
  key: 0,
  class: "fixed inset-0 z-50 justify-center items-center flex min-h-130"
}
const _hoisted_99 = { class: "relative w-4/6 my-6 mx-auto max-w-4xl" }
const _hoisted_100 = { class: "popup border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex p-5 border-b border-solid border-blueGray-200 rounded-t" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "formcontainer flex mr-2" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Link Configuration")
  ])
], -1))
const _hoisted_102 = { class: "p-3 w-3/6" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Select Configuration", -1))
const _hoisted_104 = ["onUpdate:modelValue"]
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "0",
  selected: "",
  hidden: "",
  disabled: ""
}, "Please select screen", -1))
const _hoisted_106 = ["value"]
const _hoisted_107 = { class: "buttonposition flex justify-end items-right mb-4 mx-2" }
const _hoisted_108 = {
  key: 1,
  class: "opacity-25 fixed inset-0 z-40 bg-black"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.onlyDataShow || _ctx.clickonRow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("input", {
                          id: "workflowName",
                          type: "text",
                          class: "inputboxstyling",
                          placeholder: "Name of the workflow",
                          disabled: "",
                          value: _ctx.workflows[0].workFlowName
                        }, null, 8, _hoisted_11)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _withDirectives(_createElementVNode("select", {
                          class: "inputboxstyling",
                          disabled: "",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.workflows[0].linked) = $event))
                        }, [
                          _hoisted_14,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configList, (config) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: config._id,
                              key: config._id
                            }, _toDisplayString(config.name), 9, _hoisted_15))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.workflows[0].linked]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("button", {
                          class: "btnprimary h-8 flex justify-center items-center",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editStatus()))
                        }, [
                          _hoisted_17,
                          _createTextVNode(" Edit ")
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_18
                ]),
                _createElementVNode("table", null, [
                  _hoisted_19,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workflows[0].statuses, (status) => {
                      return (_openBlock(), _createElementBlock("tr", { key: status }, [
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(status.label) + " ", 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(status.stages, (stage) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: stage._id,
                              class: "change"
                            }, [
                              _createElementVNode("div", _hoisted_20, _toDisplayString(status.label), 1)
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_21, _toDisplayString(status.label), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(status.stages, (stage) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: stage._id,
                              class: "change mt-3"
                            }, _toDisplayString(stage.label), 1))
                          }), 128))
                        ]),
                        _createElementVNode("td", null, [
                          (status.label == 'CLOSED')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("div", null, _toDisplayString(status.label), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createElementVNode("div", null, _toDisplayString(status.toLabel), 1)
                              ])),
                          (status.label == 'CLOSED')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("div", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(status.stages, (stage) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: stage._id,
                                      class: "change"
                                    }, _hoisted_26))
                                  }), 128))
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(status.stages, (stage) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: stage._id,
                                    class: "change mt-4"
                                  }, [
                                    _createElementVNode("div", null, _toDisplayString(stage.toLabel), 1)
                                  ]))
                                }), 128))
                              ]))
                        ]),
                        _createElementVNode("td", null, _toDisplayString((_ctx.optionsUserArray.find((obj)=>obj.value == status.authority)).label), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("button", {
                    class: "btnprimary mr-1.5",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeWorkflow()))
                  }, "Close")
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.clickOnEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workflows, (workFlow, workFlowindex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: workFlow._id
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _hoisted_36,
                            _withDirectives(_createElementVNode("input", {
                              id: "workflowName",
                              type: "text",
                              class: _normalizeClass(["inputboxstyling", {
															'is-invalid':_ctx.v$.workflows[0].workFlowName.$error }]),
                              placeholder: "Name of the workflow",
                              "onUpdate:modelValue": ($event: any) => ((workFlow.workFlowName) = $event)
                            }, null, 10, _hoisted_37), [
                              [_vModelText, workFlow.workFlowName]
                            ]),
                            (_ctx.v$.workflows[0].workFlowName.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                  (_ctx.v$.workflows[0].workFlowName.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _hoisted_41,
                            _withDirectives(_createElementVNode("select", {
                              class: "inputboxstyling",
                              "onUpdate:modelValue": ($event: any) => ((workFlow.linked) = $event)
                            }, [
                              _hoisted_43,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configList, (config) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: config._id,
                                  key: config._id
                                }, _toDisplayString(config.name), 9, _hoisted_44))
                              }), 128))
                            ], 8, _hoisted_42), [
                              [_vModelSelect, workFlow.linked]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("button", {
                              class: "btnprimary relative flex justify-center items-center",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showBlock=!_ctx.showBlock))
                            }, [
                              _createTextVNode("Add "),
                              _hoisted_46
                            ]),
                            (_ctx.showBlock)
                              ? (_openBlock(), _createElementBlock("ul", _hoisted_47, [
                                  _createElementVNode("li", {
                                    onClick: ($event: any) => (_ctx.addStatus(workFlow, 'Need for Approval')),
                                    class: "px-3 py-3"
                                  }, "Need for Approval", 8, _hoisted_48),
                                  _hoisted_49,
                                  _createElementVNode("li", {
                                    onClick: ($event: any) => (_ctx.addStatus(workFlow, 'status')),
                                    class: "px-3 py-3"
                                  }, "Status", 8, _hoisted_50)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _hoisted_51
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("table", null, [
                        _hoisted_53,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workFlow.statuses, (status, statusIndex) => {
                          return (_openBlock(), _createElementBlock("tr", { key: statusIndex }, [
                            _createElementVNode("td", null, [
                              (status.label == 'Open' || status.label == 'Closed' || status.label == 'Need for Approval' )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                    _createTextVNode(_toDisplayString(status.label) + " ", 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(status.stages, (stage) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: stage.id,
                                        class: "mt-1 change",
                                        style: {"visibility":"hidden"}
                                      }, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "inputboxstyling",
                                          "onUpdate:modelValue": ($event: any) => ((status.label) = $event),
                                          onBlur: ($event: any) => (_ctx.addStatusAddress(status.label))
                                        }, null, 40, _hoisted_55), [
                                          [_vModelText, status.label]
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      class: _normalizeClass(["inputboxstyling", {'is-invalid': _ctx.v$.workflows[workFlowindex].$error && !_ctx.v$.workflows[workFlowindex].statuses.$each.$response.$data[statusIndex].label.required }]),
                                      "onUpdate:modelValue": ($event: any) => ((status.label) = $event),
                                      onBlur: ($event: any) => (_ctx.addStatusAddress(status.label))
                                    }, null, 42, _hoisted_57), [
                                      [_vModelText, status.label]
                                    ]),
                                    (_ctx.v$.workflows[workFlowindex].$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                          (!_ctx.v$.workflows[workFlowindex].statuses.$each.$response.$data[statusIndex].label.required)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_59, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(status.stages, (stage) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: stage.id,
                                        class: "mt-1 change",
                                        style: {"visibility":"hidden"}
                                      }, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "inputboxstyling",
                                          "onUpdate:modelValue": ($event: any) => ((stage.label) = $event),
                                          onBlur: ($event: any) => (_ctx.addStatusAddress(stage.label))
                                        }, null, 40, _hoisted_60), [
                                          [_vModelText, stage.label]
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", null, [
                                _hoisted_61,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(status.stages, (stage, stageIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: stage.id,
                                    class: "mt-1 change"
                                  }, [
                                    _createElementVNode("div", _hoisted_62, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: _normalizeClass(["inputboxstyling", {
																'is-invalid': _ctx.v$.workflows[workFlowindex].$error && !_ctx.v$.workflows[workFlowindex].statuses.$each.$response.$data[statusIndex].stages.$each.$data[stageIndex].label.required
																}]),
                                        "onUpdate:modelValue": ($event: any) => ((stage.label) = $event),
                                        onBlur: ($event: any) => (_ctx.addStageAddress(stage.label))
                                      }, null, 42, _hoisted_63), [
                                        [_vModelText, stage.label]
                                      ]),
                                      (_ctx.v$.workflows[workFlowindex].$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                            (!_ctx.v$.workflows[workFlowindex].statuses.$each.$response.$data[statusIndex].stages.$each.$data[stageIndex].label.required)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_65, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_66, [
                                _withDirectives(_createElementVNode("select", {
                                  class: _normalizeClass(["inputboxstyling jaga", { 'is-invalid':_ctx.v$.workflows[workFlowindex].$error && !_ctx.v$.workflows[workFlowindex].statuses.$each.$response.$data[statusIndex].toLabel.required }]),
                                  "onUpdate:modelValue": ($event: any) => ((status.toLabel) = $event)
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsData, (obj) => {
                                    return (_openBlock(), _createElementBlock("optgroup", {
                                      key: obj,
                                      label: obj.label
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(obj.options, (option) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          value: option,
                                          key: option
                                        }, _toDisplayString(option), 9, _hoisted_69))
                                      }), 128))
                                    ], 8, _hoisted_68))
                                  }), 128))
                                ], 10, _hoisted_67), [
                                  [_vModelSelect, status.toLabel]
                                ]),
                                (_ctx.v$.workflows[workFlowindex].$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                      (!_ctx.v$.workflows[workFlowindex].statuses.$each.$response.$data[statusIndex].toLabel.required)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(status.stages, (stage, stageIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: stage.id,
                                  class: "mt-1 change"
                                }, [
                                  _createElementVNode("div", _hoisted_72, [
                                    _withDirectives(_createElementVNode("select", {
                                      class: _normalizeClass(["inputboxstyling", {'is-invalid':_ctx.v$.workflows[workFlowindex].$error && !_ctx.v$.workflows[workFlowindex].statuses.$each.$response.$data[statusIndex].stages.$each.$data[stageIndex].toLabel.required}]),
                                      "onUpdate:modelValue": ($event: any) => ((stage.toLabel) = $event)
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsData, (obj) => {
                                        return (_openBlock(), _createElementBlock("optgroup", {
                                          key: obj,
                                          label: obj.label
                                        }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(obj.options, (option) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              value: option,
                                              key: option
                                            }, _toDisplayString(option), 9, _hoisted_75))
                                          }), 128))
                                        ], 8, _hoisted_74))
                                      }), 128))
                                    ], 10, _hoisted_73), [
                                      [_vModelSelect, stage.toLabel]
                                    ]),
                                    (_ctx.v$.workflows[workFlowindex].$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                          (!_ctx.v$.workflows[workFlowindex].statuses.$each.$response.$data[statusIndex].stages.$each.$data[stageIndex].toLabel.required)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_77, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128))
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_78, [
                                _withDirectives(_createElementVNode("select", {
                                  class: _normalizeClass(["inputboxstyling", {'is-invalid':_ctx.v$.workflows[workFlowindex].$error && !_ctx.v$.workflows[workFlowindex].statuses.$each.$response.$data[statusIndex].authority.required}]),
                                  "onUpdate:modelValue": ($event: any) => ((status.authority) = $event)
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsUserArray, (option) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: option,
                                      value: option.value
                                    }, _toDisplayString(option.label), 9, _hoisted_80))
                                  }), 128))
                                ], 10, _hoisted_79), [
                                  [_vModelSelect, status.authority]
                                ]),
                                (_ctx.v$.workflows[workFlowindex].$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                      (!_ctx.v$.workflows[workFlowindex].statuses.$each.$response.$data[statusIndex].authority.required)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_82, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_83, [
                                _createElementVNode("div", {
                                  class: "px-1 py-0 cursor-pointer",
                                  onClick: ($event: any) => (_ctx.addStage(workFlowindex, statusIndex))
                                }, _hoisted_86, 8, _hoisted_84),
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (_ctx.ondelete(workFlowindex, statusIndex)),
                                  class: "px-1 py-0 cursor-pointer"
                                }, _hoisted_89, 8, _hoisted_87)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(status.stages, (stage, stageIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: stage.id,
                                  class: "mt-1 change flex flex-row justify-center"
                                }, [
                                  _createElementVNode("div", _hoisted_90, [
                                    _hoisted_91,
                                    _createElementVNode("div", {
                                      onClick: ($event: any) => (_ctx.ondeletestage(workFlowindex, statusIndex, stageIndex)),
                                      class: "px-1 py-0 cursor-pointer"
                                    }, _hoisted_94, 8, _hoisted_92)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["mr-6", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancelWorkflow()))
                      }, "Cancel", 2),
                      (this.pageType == 'create')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.saveWorkFlow(workFlow,workFlowindex)),
                            class: _normalizeClass(_ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none')
                          }, "Save", 10, _hoisted_96))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: _normalizeClass(["btnprimary", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            onClick: ($event: any) => (_ctx.updateWorkFlow(workFlow))
                          }, "Update", 10, _hoisted_97))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workflows, (workFlow) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "Popup",
        key: workFlow._id
      }, [
        (_ctx.linkPopup)
          ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, [
                  _hoisted_101,
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_102, [
                      _hoisted_103,
                      _withDirectives(_createElementVNode("select", {
                        class: "inputboxstyling",
                        "onUpdate:modelValue": ($event: any) => ((workFlow.linked) = $event)
                      }, [
                        _hoisted_105,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configList, (config) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: config._id,
                            key: config._id
                          }, _toDisplayString(config.name), 9, _hoisted_106))
                        }), 128))
                      ], 8, _hoisted_104), [
                        [_vModelSelect, workFlow.linked]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_107, [
                    _createElementVNode("button", {
                      class: "btnprimary mr-1.5",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.linkPopup = !_ctx.linkPopup))
                    }, "Cancel"),
                    _createElementVNode("button", {
                      class: "btnprimary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.saveConfiguration()))
                    }, "Save")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.linkPopup)
          ? (_openBlock(), _createElementBlock("div", _hoisted_108))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}